import React from "react";
import Navbar from "../../Navbar/Navbar";
import ModelStorefront from "./ModelStorefront";
import ScroollTableStorefront from "./ScroollTableStorefront";
import { ProductConsumer } from "../../Context/AddProWakel";
import "../shared/rtl-panel.css";

const FILTERS = [
    { value: "all", label: "هەموو", icon: "fa-list" },
    { value: "published", label: "بڵاوکراوە", icon: "fa-globe" },
    { value: "hidden", label: "شاراوە", icon: "fa-eye-slash" },
];

class AllStorefrontPage extends React.Component {
    render() {
        return (
            <div>
                <Navbar />
                <ProductConsumer>
                    {(value) => <StorefrontBody value={value} />}
                </ProductConsumer>
                <ModelStorefront />
            </div>
        );
    }
}

class StorefrontBody extends React.Component {
    componentDidMount() {
        this.props.value.SF_getProducts();
        // Categories feed the per-row assignment dropdown (CATEGORY_API.md §4.5).
        this.props.value.CT_getCategories();
    }

    // Exact per-status counts need the full set. When paged (idle), we only know
    // the server total, so show that on "all" and omit the per-status counts.
    counts = (products, paged, total) => ({
        all: paged ? total : products.length,
        published: paged ? null : products.filter((p) => p.isPublished).length,
        hidden: paged ? null : products.filter((p) => !p.isPublished).length,
    });

    render() {
        const {
            SF_search,
            SF_loading,
            SF_products,
            SF_getProducts,
            SF_paged,
            SF_total,
            SF_filter,
            SF_setFilter,
            SF_searchChangeStore,
        } = this.props.value;
        const counts = this.counts(SF_products, SF_paged, SF_total);

        return (
            <div className="rs-page" dir="rtl">
                <div className="rs-toolbar">
                    <h5 className="rs-toolbar__title">
                        <i className="fas fa-store"></i>
                        بەڕێوەبردنی فرۆشگای ئۆنڵاین
                    </h5>

                    <span className="rs-toolbar__sep" />

                    <div className="rs-seg">
                        {FILTERS.map((f) => (
                            <button
                                key={f.value}
                                className={`rs-seg__btn ${SF_filter === f.value ? "is-active" : ""
                                    }`}
                                onClick={() => SF_setFilter(f.value)}
                            >
                                <i className={`fas ${f.icon}`}></i>
                                {f.label}
                                {counts[f.value] != null && (
                                    <span className="rs-seg__count">({counts[f.value]})</span>
                                )}
                            </button>
                        ))}
                    </div>

                    <div className="rs-field rs-field--grow">
                        <label className="rs-field__label" htmlFor="SF_search">
                            گەڕان
                        </label>
                        <input
                            id="SF_search"
                            type="text"
                            name="SF_search"
                            value={SF_search}
                            onChange={SF_searchChangeStore}
                            placeholder="گەڕان بە ناو یان کۆد..."
                            className="rs-input"
                        />
                    </div>

                    <button
                        className="rs-btn rs-btn--ghost"
                        onClick={SF_getProducts}
                        disabled={SF_loading}
                    >
                        {SF_loading ? (
                            <i className="fas fa-spinner fa-spin"></i>
                        ) : (
                            <>
                                <i className="fas fa-sync"></i>
                                نوێکردنەوە
                            </>
                        )}
                    </button>
                </div>

                <ScroollTableStorefront filter={SF_filter} />
            </div>
        );
    }
}

export default AllStorefrontPage;
